import JobPost from '@/apps/job_post/JobPost.vue';
import JobPostTypeOfCare from '@/apps/job_post/JobPostTypeOfCare.vue';
import JobPostLocation from '@/apps/job_post/JobPostLocation.vue';
import JobPostDetails from '@/apps/job_post/JobPostDetails.vue';
import JobPostSchedule from '@/apps/job_post/schedule/JobPostSchedule.vue';
import JobPostConfirm from '@/apps/job_post/confirm/JobPostConfirm.vue';
import JobPostFamilyDetails from '@/apps/job_post/JobPostFamilyDetails.vue';
import JobPostRates from '@/apps/job_post/JobPostRates.vue';
import JobPostRequirements from '@/apps/job_post/requirements/JobPostRequirements.vue';
import { requireSeeker } from '../guards/authGuards';
import setSimpleHeaderGuard from '../guards/simpleHeaderGuard';
import combineGuards from '../guards/helpers';

const jobPostRoutes = [
  {
    path: '/job-post',
    component: JobPost,
    beforeEnter: combineGuards([requireSeeker, setSimpleHeaderGuard]),
    children: [
      {
        path: 'location',
        name: 'job-post-location',
        component: JobPostLocation,
        meta: {
          stepLabel: 'Location',
        },
      },
      {
        path: 'select-schedule',
        name: 'job-post-select-schedule',
        component: JobPostTypeOfCare,
        meta: {
          stepLabel: 'Type of Care',
        },
      },
      {
        path: 'schedule',
        name: 'job-post-schedule',
        component: JobPostSchedule,
        meta: {
          stepLabel: 'Schedule',
        },
      },
      {
        path: 'family-details',
        name: 'job-post-family-details',
        component: JobPostFamilyDetails,
        meta: {
          stepLabel: 'Family',
        },
      },
      {
        path: 'rates',
        name: 'job-post-rates',
        component: JobPostRates,
        meta: {
          stepLabel: 'Rates',
        },
      },
      {
        path: 'requirements',
        name: 'job-post-requirements',
        component: JobPostRequirements,
        meta: {
          stepLabel: 'Requirements',
        },
      },
      {
        path: 'details',
        name: 'job-post-details',
        component: JobPostDetails,
        meta: {
          stepLabel: 'Details',
        },
      },
      { path: 'confirm', name: 'job-post-confirm', component: JobPostConfirm },
      { path: '*', redirect: { name: 'job-post-location' } },
      {
        path: '',
        redirect: { name: 'job-post-location' },
      },
    ],
  },
];

export default jobPostRoutes;
